import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Loading from "components/Loading";
import Purchase from "./Purchase";

const Purchases = ({
  purchases,
  loading,
  accessCourseLink,
  accessFreeCourseLink
}) => {
  return !loading ? (
    <>
      <div className="contentPage__headingDiv">
        <h1>Purchase History</h1>
        <h6>
          A list of every product you’ve purchased through HealthStream
          Marketplace.
        </h6>
      </div>
      <div className="purchaseHistoryBlock" style={{ position: "relative" }}>
        <div>
          {purchases.map(purchase => (
            <Purchase
              key={purchase.orderNumber}
              purchase={purchase}
              accessCourseLink={accessCourseLink}
              accessFreeCourseLink={accessFreeCourseLink}
            />
          ))}
          <p className="questions">
            <span className="d-inline-block me-2">
              Questions about an order?
            </span>
            <Link to="/contact-us">Contact us</Link>.
          </p>
        </div>
      </div>
    </>
  ) : (
    <Loading />
  );
};

Purchases.propTypes = {
  accessCourseLink: PropTypes.string.isRequired,
  accessFreeCourseLink: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  purchases: PropTypes.array.isRequired
};

export default Purchases;
